import axios from '../../../axios';
import { IBusinessUnit } from '../../ClientManagementSettings';
import { ITeamFilters } from '../../TeamSearchService';
import { IWorkspace, IWorkspaceAdmin, IWorkspaceUser } from '../../WorkspaceService';
import IUserDTO from '../types/IUserDTO';
import IWorkspaceInvitationDTO from '../types/IWorkspaceInvitationDTO';

export const saveUser = (payload: IUserDTO) => axios.put('api/recruiters', payload);
const recruiterUrl = '/api/recruiters';

const url = '/api/workspace';

const userUrl = '/api/users';

export const getUser = () => axios.get(`${recruiterUrl}/loggedinrecruiter`);

export const getRecruiterByEmail = (email: string) =>
  axios.get(`${recruiterUrl}/findonebyemail?email=${email}`);

export const getUserByEmail = (email: string) =>
  axios.get(`${userUrl}/findonebyemail?email=${email}`);

export const inviteUser = (data: IWorkspaceInvitationDTO) => axios.put(`${url}/invite`, data);

export const getInvitedUsersInWorkspace = (teamFilters: ITeamFilters) =>
  axios.post(`${url}/invitations`, teamFilters);

export const getInvitedUsersInWorkspaceList = () => axios.get(`${url}/invited`);

export const updateUserRole = (data: IWorkspace) => axios.put(`${url}/update-role`, data);

export const updateBusinessUnitById = (
  data: IBusinessUnit[],
  userId: string,
  workspaceId: string
) => axios.put(`${url}/updateBuisnessUnitById/${userId}/${workspaceId}`, data);

export const updateUserStatus = (data: IWorkspaceUser) => axios.put(`${url}/update-status`, data);

export const searchInvitesUsingEmail = (email: string) =>
  axios.get(`${url}/` + email + '/workspace-user');

export const searchInvitesUsingEmails = (emails: string[]) =>
  axios.post(`${url}/workspace-users`, emails);

export const getWorkspaceInvitationsForSuperAdmin = (email: string) =>
  axios.get(`${url}/` + email + '/all-invitations');

export const checkIfUserDisabled = (userId: string, workspaceId: string) =>
  axios.get(`${url}/${userId}/${workspaceId}/disabled-users-search-admin`);

export const addToDisabledUsers = (userId: string, workspaceId: string) =>
  axios.get(`${url}/${userId}/${workspaceId}/disable-user-admin`);

export const removeFromDisabledUsers = (userId: string, workspaceId: string) =>
  axios.get(`${url}/${userId}/${workspaceId}/enable-user-admin`);

export const updatedUserMFA = (userEmail: string, enabled: boolean) =>
  axios.post(`${url}/toggle-mfa/${userEmail}/${enabled}`, {
    disableOTPValidation: enabled,
    userId: userEmail,
  });

export const getOTPExpiryTime = () => axios.get('/api/otp-expiry-time');

export const getUsersByStatusInWorkspace = (status: string[]) =>
  axios.post(`${url}/getuser-by-status`, status);

export const getUsersInWorkspace = (payload: IWorkspaceAdmin) =>
  axios.post(`${url}/get-users`, payload);

export const downloadWorkspaceUsersData = (url: string) =>
  axios.post(url, {
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    responseType: 'arraybuffer',
  });

export const getInvitedUsersInWorkspaceAdmin = (
  id: string,
  pagingToken: string,
  pageNumber: number,
  pageSize: number
) =>
  axios.post(`${url}/${id}/invitations/${pagingToken}`, {
    pageNumber: pageNumber,
    pageSize: pageSize,
  });

export const getInvitedUsersInWorkspaceAdminForId = (
  id: string,
  pageNumber: number,
  pageSize: number
) =>
  axios.post(`${url}/${id}/invitations/`, {
    pageNumber: pageNumber,
    pageSize: pageSize,
  });

export const getUserById = (id: string) => axios.get(`${recruiterUrl}/${id}`);

export const usersAutoComplete = (search: string, signal: AbortSignal) =>
  axios.get(`recruitersearch/api/user/autocomplete?search=${search}`, {
    signal,
  });

export const accountManagerAutoComplete = (search: string, signal: AbortSignal) =>
  axios.get(`api/account-manager/autocomplete?search=${search}`, {
    signal,
  });

export const usersAutoCompleteNew = (search: string, signal: AbortSignal) =>
  axios.get(`api/user/autocomplete?search=${search}`, {
    signal,
  });
